import { render, staticRenderFns } from "./ResidenceRecord.vue?vue&type=template&id=0d46d466&scoped=true&"
import script from "./ResidenceRecord.vue?vue&type=script&lang=js&"
export * from "./ResidenceRecord.vue?vue&type=script&lang=js&"
import style0 from "./ResidenceRecord.vue?vue&type=style&index=0&id=0d46d466&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d46d466",
  null
  
)

export default component.exports